export const BITCOIN_API_ADDRESS = "/api";
export const WISH_STATE_OPEN = "open";
export const NOTIFICATIONS_DROPDOWN_NR = 5;
// export const FB_APP_ID = '1225717134199251';
